import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { menuCreator } from '../module/menuCreator';
export const store = new Vuex.Store({
    state: {
        //==============================================  
        groups: [],
        navbarmenu: [],
        sliders: [],
        amazingOffers: [],
        promoSectionProducts: [],
        brands: [],
        suggestedProducts: [],
        homePageContents: null,
        banners: [], 
        customerGroupId: null,
        baseInfo: null,
        //==============================================  
        userFullName: '',
        mobNo : '' ,
        //==============================================
        confirm: {
            confirmationCodeHashId: '',
            timeRemaningForExpire: 0
        },
        //==============================================
        cart: null,
    },

    getters: {
        //============================================== 
        readGroups: state => {
           return state.groups;
        },
        readNavbarmenu: state => {
            return state.navbarmenu;
        },
        readSliders: state => {
            return state.sliders;
        },
        readAmazingOffers: state => {
            return state.amazingOffers;
        },
        readPromoSectionProducts: state => {
            return state.promoSectionProducts;
        },
        readHomePageContents: state => {
            return state.homePageContents;
        },
        readBrands: state => {
            return state.brands;
        },
        readSuggestedProducts: state => {
            return state.suggestedProducts;
        },
        readBaseInfo: state => {
            return state.baseInfo;
        },
        //============================================== 
        readUserFullName: state => {
            return state.userFullName;
        },
        //============================================== 
        readCustomerGroupId: state => {
            return state.customerGroupId;
        },
        readUserMobNo: state => {
            return state.mobNo;
        },
        //==============================================
        readConfirm: state => {
            return state.confirm;
        },
        //===============================================
        readCart: state => {
            return state.cart
        }, 
        readBanners: state => {
            return state.banners
        }
    },
    mutations: {
        //============================================== 
        setHomePageContents: (state, data) => {
            state.homePageContents = data;
            state.groups = data.Groups;
            state.navbarmenu = menuCreator(state.groups);
            state.sliders = data.Sliders;
            state.amazingOffers = data.AmazingOffers;
            state.promoSectionProducts = data.PromoSectionProducts;
            state.brands = data.Brands;
            state.suggestedProducts = data.SuggestedProducts;
            state.userFullName = data.CustomerFullName;
            state.customerGroupId = data.CustomerGroupId;
            state.mobNo = data.MobileNo;
            state.banners = data.Banners, 
            state.baseInfo = data.BaseInfos;
            if (data.IsUserLogined == false)
                localStorage.removeItem('accessToken');
        },
        //============================================== 
        setUserFullName: (state, data) => {
            state.userFullName = data;
        },
        //==============================================
        setConfirm: (state, data) => {
            state.confirm.confirmationCodeHashId = data.ConfirmationCodeHashId;
            state.confirm.timeRemaningForExpire = data.TimeRemaningForExpire;
        },
        //==============================================
        setCart: (state, data) => {
            state.cart = data;
        }
        //==============================================
    }
});